﻿//Query global
import $ from 'jquery';
window.$ = window.jQuery = $;

// Importación de select2 via require (usa la instancia global de jQuery)
require('select2')(window.$);

// Configuración de idioma para Select2 (global, imports estáticos)
const lang = (document.documentElement.lang || navigator.language || 'en').toLowerCase();
if (lang.startsWith('es')) {
  require('select2/dist/js/i18n/es');
  $.fn.select2.defaults.set('language', 'es');
} else if (lang.startsWith('pt')) {
  require('select2/dist/js/i18n/pt');
  $.fn.select2.defaults.set('language', 'pt');
} else {
  $.fn.select2.defaults.set('language', 'en');
}

(async () => {
  // Plugins de JQuery
  await import('jquery-validation');
  await import('jquery-validation-unobtrusive');

  // importación de bootstrap y popper
  const bootstrapNS = await import('bootstrap');
  window.bootstrap = bootstrapNS;
  await import('bootstrap-select');

  // Session interceptor: catch 401/X-Session-Expired on all fetch calls
  await import('./dashboard/common/session-interceptor.js');

  // Cross-tab idle sync: coordinate activity across browser tabs
  await import('./dashboard/common/idle-tab-sync.js');

  // Scripts custom globales
  await import('./site');
  await import('./ajax-loader');
  await import('./toast-custom');
})();
